module.exports = __webpack_public_path__ + "img/1354277138.e678836e.jpg";